import axios from 'axios';
import API_BASE from './apiConfig';

const apiClient = axios.create({
  baseURL: API_BASE.replace(/\/$/, ''),
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  if (!config.withCredentials) {
    config.withCredentials = true;
  }
  return config;
});

export default apiClient;
